var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-gant-plus-row",style:({ background: _vm.config.color, left: `${_vm.startDateDay * _vm.plus.config.dayWidth}px`, height: _vm.config.height, width: `${_vm.lengthDay * _vm.plus.config.dayWidth}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }